export default function Saturn404() {
	return (<h3>NOT FOUND IN SATURN</h3>);
}